import React, { useEffect, useState,useRef, useMemo } from "react";
import { Driver,Vehicle } from "../../objects/policy";
import { v4 as uuidv4 } from 'uuid';
import EditVehicleForm from "../EditVehicleForm";

function ListVehicles(props: any){
    let counter = 0;
    
    const[currentKey, setCurrentKey] = useState("");
    const { policyState, vehicles, removeVehicleAction,onClose ,onSaveAction, onUpdateVehicleAction } = props;
    const [stateVehicles, setStateVehicles] = useState<Vehicle[]>(vehicles);
    
    useEffect(()=>{
        
    }, [stateVehicles]);

    function onRemoveVehicle(e: any, carNumber: number){
        var removedVehicles = removeVehicleAction(e, carNumber);
        setStateVehicles(removedVehicles);        
        document.querySelector(".row-edit-vehicle[data-index='"+carNumber+"'")?.classList.toggle("rounded-br-lg");
        document.querySelector(".row-edit-vehicle[data-index='"+carNumber+"'")?.classList.toggle("rounded-bl-lg");
    }

    function onEditVehicle(e: any, carNumber: any, containerKey: string) {
        
        if(containerKey === currentKey){
            setCurrentKey("");
        } else{
            setCurrentKey(containerKey);
        }
       
        document.querySelector(".row-edit-vehicle[data-index='"+carNumber+"'")?.classList.toggle("rounded-br-lg");
        document.querySelector(".row-edit-vehicle[data-index='"+carNumber+"'")?.classList.toggle("rounded-bl-lg");
    }

    return (
        <>
            {
                (stateVehicles as Vehicle[]).map((v:Vehicle,k:any) => {
                    var containerKey = "container-edit-vehicle-" + counter;
                    counter++
                    return <>
                        <div data-containerkey={containerKey}  key={uuidv4()} className="row-edit-vehicle bg-[#e5eff1] p-5 rounded-tl-lg rounded-tr-lg rounded-br-lg rounded-bl-lg" onClick={ (e)=>{  }}>
                            <span className="truncate w-11/12 sm:w-11/12 md:w-auto lg:w-auto xl:w-auto 2xl:w-auto text-ellipsis float-left font-bold text-lg text-ford-blue">{v.year} {v.make} {v.model}</span>
                            <div className="clear-both hidden sm:visible md:visible lg:hidden xl:hidden 2xl:hidden" />
                            <span data-containerkey={containerKey} 
                                    key={uuidv4()} 
                                    onClick={(e)=>{ onEditVehicle(e, v.carNumber, containerKey) }} 
                                    className="w-auto float-right text-ford-blue text-lg border-l border-dashed pl-5 border-[#999999] hover:cursor-pointer">Edit</span>

                            <span key={uuidv4()} 
                                        onClick={(e)=>{ onRemoveVehicle(e, v.carNumber) }} 
                                        className="w-auto float-right text-lg border-l border-dashed pl-5 border-[#999999] hover:cursor-pointer pr-5 text-red-700">Remove</span>
                            
                            <span key={uuidv4()} className="float-right text-ford-blue text-lg border-l border-dashed pl-5 border-[#999999] hover:cursor-pointer hidden">Close</span>
                            <div className=" clear-both"></div>
                        </div>  

                          <EditVehicleForm 
                            key={v.carNumber}
                            action="EDIT"
                            parent="ListVehicles"
                            containerKey={containerKey} 
                            carNumber = {v.carNumber}
                            currentKey = {currentKey}
                            vehicles = {vehicles}
                            policyState={policyState}
                            isVisible={currentKey == containerKey}
                            onCloseAction={ (e:any) => { 
                                setCurrentKey(""); 
                            } }  
                            onSaveAction = { onSaveAction }
                            onUpdateVehicleAction= {onUpdateVehicleAction}
                          /> 
                    </>

                })
            }
              
        </>
    )
}

export default ListVehicles;